<!-- mettal-3\src\components\X533.vue -->
<template>
  <div :class="[`x5-2`, className || ``]">
    <img
      class="image-18"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/---------------21@2x.png"
      alt="image"
    />
    <div class="view-195">
      <p class="x01-22 poppins-semi-bold-white-16px">{{ x01 }}</p>
      <img
        class="vector-196"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-614.svg"
        alt="Vector"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "X533",
  props: ["x01", "className"],
};
</script>

<style>
.x5-2 {
  background-color: var(--storm-dust-2);
  border-radius: 12px;
  height: 90px;
  margin-left: 4px;
  margin-top: 6px;
  position: relative;
  width: 300px;
}

.image-18 {
  height: 86px;
  left: 4px;
  position: absolute;
  top: 3px;
  width: 293px;
}

.view-195 {
  height: 72px;
  left: 25px;
  position: absolute;
  top: 10px;
  width: 245px;
}

.text-24-1 {
  left: 0;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 54px;
}

.x01-22 {
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 0;
  width: 203px;
}

.vector-196 {
  height: 23.15%;
  left: 0;
  position: absolute;
  top: 8.33%;
  width: 10.2%;
}

.x5-2.view-185-item {
  margin-top: 12px;
}

.x5-2.view-item-1 {
  margin-left: 5px;
  margin-top: 12px;
}
</style>
